"use client";
import Script from "next/script";
import { usePathname } from "next/navigation";

// 19/10/26 (Founder "תפעל"): Google Ads remarketing tag ONLY (AW-17944998107) so the Ads account can build visitor lists.
// NOT GA4 / GTM (removed 07/10). No conversion actions. Skipped on /admin and /pro. Loads after idle: no render block, no layout shift.
const AW_ID = "AW-17944998107";
export default function AdsRemarketingTag() {
  const p = usePathname() || "";
  if (p === "/admin" || p.startsWith("/admin/") || p === "/pro" || p.startsWith("/pro/")) return null;
  return (
    <>
      <Script id="aw-init" strategy="lazyOnload">{`window.dataLayer=window.dataLayer||[];window.gtag=window.gtag||function(){dataLayer.push(arguments)};gtag("js",new Date());gtag("config","${AW_ID}");`}</Script>
      <Script id="aw-src" src={"https://www.googletagmanager.com/gtag/js?id=" + AW_ID} strategy="lazyOnload" />
    </>
  );
}
